import { Component } from '@theme/component';
import { onAnimationEnd } from '@theme/utilities';
import { ThemeEvents, CartUpdateEvent } from '@theme/events';

document.addEventListener("change", async (e) => {
  if (!e.target.matches(".card-qty-input")) return;

  const input = e.target;
  const variantId = input.dataset.variantId;
  const quantity = parseInt(input.value);

  if (!variantId) return;

  try {
    // Get current cart
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    const existingItem = cart.items.find(item => item.id == variantId);

    let response;

    if (existingItem) {
      response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });
    } else if (quantity > 0) {
      response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });
    }

    const updatedCart = await response.json();

    // ✅ THIS is the missing piece for your theme
    document.dispatchEvent(new CustomEvent(ThemeEvents.cartUpdate, {
      detail: {
        data: {
          itemCount: updatedCart.item_count,
          source: 'custom-card-quantity'
        }
      }
    }));
    document.dispatchEvent(new Event('cart:refresh'));

  } catch (err) {
    console.error("Cart update failed:", err);
  }
});